import React from 'react';
import { NavLink, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AdminBrands from '../../pages/admin/AdminBrands';
import AdminRegions from '../../pages/admin/AdminRegions';
import AdminSettings from '../../pages/admin/AdminSettings';

const NAV_ITEMS = [
  { to: '/admin/brands',   label: 'Brand' },
  { to: '/admin/regions',  label: 'Regioni' },
  { to: '/admin/settings', label: 'Impostazioni' },
];

const AdminLayout = () => {
  const { username, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-black text-white">
      {/* Sidebar (desktop) / Top bar (mobile) */}
      <aside className="w-full md:w-56 bg-gray-900 border-b md:border-b-0 md:border-r border-gray-800 flex flex-col shrink-0">
        {/* Logo + logout (logout inline solo su mobile) */}
        <div className="flex items-center justify-between md:block px-4 md:px-6 py-3 md:py-6 border-b border-gray-800">
          <img
            src="/images/galimberti-logo.png"
            alt="Galimberti Rappresentanze"
            className="h-9 w-auto md:h-auto md:w-full object-contain"
          />
          <p className="hidden md:block text-xs text-gray-500 mt-2 text-center">Admin Panel</p>
          <button
            onClick={handleLogout}
            className="md:hidden text-xs px-3 py-1.5 rounded-lg border border-gray-700 text-gray-400 hover:text-red-400 hover:border-red-500 transition shrink-0"
          >
            Logout
          </button>
        </div>

        {/* Nav: orizzontale su mobile, verticale su desktop */}
        <nav className="flex md:flex-col md:flex-1 md:py-4 overflow-x-auto">
          {NAV_ITEMS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center justify-center md:justify-start px-4 md:px-6 py-3 text-sm whitespace-nowrap transition-colors border-b-2 md:border-b-0 md:border-l-2 ${
                  isActive
                    ? 'text-white bg-gray-800 border-red-500'
                    : 'text-gray-400 border-transparent hover:text-white hover:bg-gray-800/50'
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Footer con username + logout (solo desktop) */}
        <div className="hidden md:block px-6 py-4 border-t border-gray-800">
          <p className="text-xs text-gray-500 mb-2 truncate">{username}</p>
          <button
            onClick={handleLogout}
            className="w-full text-xs px-3 py-2 rounded-lg border border-gray-700 text-gray-400 hover:text-red-400 hover:border-red-500 transition"
          >
            Logout
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
        <Routes>
          <Route path="brands"   element={<AdminBrands />} />
          <Route path="regions"  element={<AdminRegions />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="*"        element={<Navigate to="/admin/brands" replace />} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminLayout;
